<template>
  <div id="app" class="d-flex flex-column min-vh-100 theme6" ref="baseBody">
    <!-- <div id="loader" class="position-absolute">
      <b-overlay show="true" rounded="lg"></b-overlay>
    </div> -->
    <div>
      <nav
        class="navbar navbar-vertical fixed-start navbar-expand-md navbar-vibrant navbar-dark"
        id="sidebar"
      >
        <div class="test"></div>
        <div class="container-fluid">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebarCollapse"
            aria-controls="sidebarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- Brand -->
          <router-link tag="a" class="navbar-brand" to="/">
            <img
              src="./assets/img/U_presence_warna.png"
              class="navbar-brand-img mx-auto"
              alt="..."
            />
          </router-link>

          <div class="navbar-user d-md-none">
            <!-- Dropdown -->
            <div class="dropdown">
              <!-- Toggle -->
              <a
                href="#"
                id="sidebarIcon"
                class="dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div class="avatar avatar-sm avatar-online">
                  <!-- <img src="./assets/img/avatars/profiles/avatar-1.jpg" class="avatar-img rounded-circle" alt="..."> -->
                  <span class="avatar-title rounded-circle">U</span>
                </div>
              </a>

              <!-- Menu -->
              <div
                class="dropdown-menu dropdown-menu-end"
                aria-labelledby="sidebarIcon"
              >
                <a href="./sign-in.html" class="dropdown-item">Logout</a>
              </div>
            </div>
          </div>

          <!-- Collapse -->
          <div class="collapse navbar-collapse" id="sidebarCollapse">
            <!-- Divider -->
            <!-- <hr class="navbar-divider my-3"> -->

            <!-- Heading -->
            <!-- <h6 class="navbar-heading text-colors text-dark mt-3">
              Health Management System
            </h6> -->

            <!-- Navigation -->
            <ul
              class="navbar-nav accordion mt-5"
              style="z-index: 99999999"
              role="tablist"
            >
              <li
                class="nav-item"
                v-for="(item, index) in menus"
                :key="`${item.name}${index}`"
              >
                <a
                  :class="`nav-link text-colors mx-3 ${
                    item.child && item.child.length > 0 && index > 0
                      ? 'collapsed'
                      : ''
                  } ${
                    item.click
                      ? 'isActives text-primary fw-bolder'
                      : 'hovers fw-lighter'
                  }`"
                  v-b-toggle="item.link"
                  data-navtype="parent"
                  v-if="item.child && item.child.length > 0"
                >
                  <i :class="`fe fe-${item.icon}`"></i> {{ item.name }}
                </a>
                <router-link
                  tag="a"
                  :class="`nav-link text-colors mx-3 ${
                    item.child && item.child.length > 0 && index > 0
                      ? 'collapsed'
                      : ''
                  } ${
                    item.click
                      ? 'isActives text-primary fw-bolder'
                      : 'hovers fw-lighter'
                  }`"
                  :to="
                    item.child && item.child.length > 0
                      ? `#${item.link}`
                      : item.link
                  "
                  v-else
                >
                  <i :class="`fe fe-${item.icon}`"></i> {{ item.name }}
                </router-link>
                <!-- ${(item.child && (item.child.length > 0) && index == 0) || item.click ? 'show' : ''} -->
                <b-collapse
                  :id="item.child && item.child.length > 0 ? item.link : ''"
                  v-if="item.child && item.child.length > 0"
                  :visible="item.child && item.child.length > 0 && index == 0"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <ul class="nav nav-sm flex-column accordion" role="tablist">
                    <li class="nav-item" v-for="(a, i) in item.child" :key="i">
                      <a
                        :class="`nav-link text-colors mx-3 ${
                          a.child && a.child.length > 0 && index > 0
                            ? 'collapsed'
                            : ''
                        } ${
                          a.click
                            ? 'isActives text-primary fw-bolder'
                            : 'hovers fw-lighter'
                        }`"
                        v-b-toggle="a.link"
                        data-navtype="parent"
                        v-if="a.child && a.child.length > 0"
                      >
                        {{ a.name }}
                      </a>
                      <router-link
                        tag="a"
                        :class="`nav-link mx-3 ${
                          a.click ? 'fw-bolder' : 'hovers text-white fw-lighter'
                        }`"
                        :to="a.link"
                        v-else
                      >
                        {{ a.name }}
                      </router-link>
                      <b-collapse
                        :id="a.child && a.child.length > 0 ? a.link : ''"
                        v-if="a.child && a.child.length > 0"
                        :visible="a.child && a.child.length > 0 && index == 0"
                        accordion="my-accordion-2"
                        role="tabpanel"
                      >
                        <ul class="nav nav-sm flex-column">
                          <li
                            class="nav-item"
                            v-for="(lv3, idx) in a.child"
                            :key="idx"
                          >
                            <router-link
                              tag="a"
                              :class="`nav-link mx-3 ${
                                lv3.click
                                  ? 'fw-bolder'
                                  : 'hovers text-white fw-lighter'
                              }`"
                              :to="lv3.link"
                            >
                              {{ lv3.name }}
                            </router-link>
                          </li>
                        </ul>
                      </b-collapse>
                    </li>
                  </ul>
                </b-collapse>
              </li>
            </ul>

            <!-- Divider -->
            <hr class="navbar-divider my-3" />
          </div>
          <!-- / .navbar-collapse -->
        </div>
      </nav>
      <div class="main-content">
        <nav
          class="navbar navbar-expand-md navbar-light d-none d-md-flex fixed-top"
          id="topbar"
        >
          <div class="container-fluid justify-content-end">
            <a class="navbar-brand" href="/">
              <img
                src="./assets/img/horizontal warna.png"
                class="navbar-brand-img mx-auto"
                alt="..."
              />
            </a>

            <div class="navbar-user">
              <label
                class="form-check-label"
                for="flexSwitchCheckDefault"
                style="margin-left: -10px"
                >EN</label
              >
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  @input="changesLang()"
                />
                <label class="form-check-label" for="flexSwitchCheckDefault"
                  >ID</label
                >
              </div>
              <!-- <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="changeLang" @change="changeLang = !changeLang">
                <label class="form-check-label" for="cardToggle"></label>
              </div> -->
              <!-- {{ changeLang }} -->

              <div class="dropdown me-4 d-none d-md-flex">
                <!-- Toggle -->
                <!-- <a href="#" class="navbar-user-link" role="button" data-bs-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <span class="icon active">
                    <i class="fe fe-bell"></i>
                  </span>
                </a> -->

                <!-- Menu -->
                <div class="dropdown-menu dropdown-menu-end dropdown-menu-card">
                  <div class="card-header">
                    <!-- Title -->
                    <h5 class="card-header-title">Notifications</h5>

                    <!-- Link -->
                    <a href="#!" class="small"> View all </a>
                  </div>
                  <!-- / .card-header -->
                  <div class="card-body">
                    <!-- List group -->
                    <div
                      class="list-group list-group-flush list-group-activity my-n3"
                    >
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-1.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Dianna Smiley</strong> shared your post
                              with Ab Hadley, Adolfo Hess, and 3 others.
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-2.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Ab Hadley</strong> reacted to your post
                              with a 😍
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-3.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Adolfo Hess</strong> commented
                              <blockquote class="mb-0">
                                “I don’t think this really makes sense to do
                                without approval from Johnathan since he’s the
                                one...”
                              </blockquote>
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-4.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Daniela Dewitt</strong> subscribed to you.
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-5.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Miyah Myles</strong> shared your post with
                              Ryu Duke, Glen Rouse, and 3 others.
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-6.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Ryu Duke</strong> reacted to your post
                              with a 😍
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-7.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Glen Rouse</strong> commented
                              <blockquote class="mb-0">
                                “I don’t think this really makes sense to do
                                without approval from Johnathan since he’s the
                                one...”
                              </blockquote>
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                      <a class="list-group-item text-reset" href="#!">
                        <div class="row">
                          <div class="col-auto">
                            <!-- Avatar -->
                            <div class="avatar avatar-sm">
                              <img
                                src="./assets/img/avatars/profiles/avatar-8.jpg"
                                alt="..."
                                class="avatar-img rounded-circle"
                              />
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <!-- Content -->
                            <div class="small">
                              <strong>Grace Gross</strong> subscribed to you.
                            </div>

                            <!-- Time -->
                            <small class="text-muted"> 2m ago </small>
                          </div>
                        </div>
                        <!-- / .row -->
                      </a>
                    </div>
                  </div>
                </div>
                <!-- / .dropdown-menu -->
              </div>
              <b-nav-item-dropdown right style="list-style-type: none">
                <!-- Using 'button-content' slot -->
                <template #button-content>
                  <div>
                    <i class="fe fe-user"></i>
                    {{ printName() }}
                    <i class="fe fe-chevron-down"></i>
                  </div>
                </template>
                <b-dropdown-item href="#" @click.prevent="logout">
                  Logout
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </div>
          </div>
        </nav>
        <router-view v-if="view" style="padding-top: 70px" id="content-view" />
        <!-- <div class="container"> -->
        <!-- <footer class="py-1 my-4 bg-dark" id="myfooter">
          <p class="text-center text-light my-2 small">&copy; PT Golden Energy Mines Tbk</p>
        </footer> -->
        <!-- </div> -->
      </div>
    </div>
    <footer class="bg-dark text-center text-lg-start">
      <!-- Copyright -->
      <div
        class="text-center p-3 text-light"
        style="background-color: rgba(0, 0, 0, 0.2)"
      >
        Provided by Digitech - GEMS. ©️ 2022 PT. Golden Energy Mines, Tbk.
        <!-- <a class="text-dark" href="https://mdbootstrap.com/">MDBootstrap.com</a> -->
      </div>
      <!-- Copyright -->
    </footer>
  </div>
</template>

<script>
import Keycloak from "keycloak-js";
import lang from "@/lang.json";
import { LOGOUT } from "../src/api/auth";
import axios from "axios";
export default {
  data() {
    return {
      view: false,
      kcOptions: {
        realm: process.env.VUE_APP_KEYCLOAK_REALM,
        "auth-server-url": process.env.VUE_APP_KEYCLOAK_URL,
        url: process.env.VUE_APP_KEYCLOAK_URL,
        "ssl-required": "external",
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT,
        resource: process.env.VUE_APP_KEYCLOAK_CLIENT,
        "verify-token-audience": true,
        "use-resource-role-mappings": true,
        "confidential-port": 0,
        "policy-enforcer": {}
      },
      keycloak: null,
      view: false,
      indexTemp: null,
      changeLang: false,
      menus: [
        {
          icon: "home",
          name: lang.lang.en.sidebar.home,
          link: "/",
        },
        {
          icon: "map",
          name: "Management Area",
          link: "ManagementArea",
          child: [
            {
              name: "Location Area",
              link: "/location",
            },
            {
              name: "Restricted Area",
              link: "/restricted-area",
            },
          ],
        },
        {
          icon: "map-pin",
          name: "Person on Board",
          link: "/person-on-board",
          click: false,
        },
        {
          icon: "alert-triangle",
          name: "E-Mustering",
          link: "/mustering",
          click: false,
        },
        {
          icon: "bell",
          name: "Notification",
          link: "Notification",
          child: [
            {
              name: "Running Text",
              link: "/running-text",
            },
            {
              name: "Wake Up Call",
              link: "/wake-up-call",
            },
          ],
        },
        {
          icon: "file-text",
          name: "Report",
          link: "report",
          child: [
            {
              name: "Job Readiness",
              link: "/job-readiness",
            },
            // {
            //   name: "Presence List",
            //   link: "/Presence",
            // },
            {
              name: "Presence",
              link: "/presence-detail",
            },
            {
              name: "Sick Leave",
              link: "/sick-leave",
            },
          ],
        },
      ],
      navVars: {},
      choice: [1, 2, 3, 4, 5, 6],
      pick: 1,
      expand: true,
    };
  },
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpgradeUI = true;
      });
    }
    this.keycloak = new Keycloak(this.kcOptions);
    this.authenticate();
  },
  mounted() {
    // console.log("language", lang.lang);
    // console.log("menus", this.menus);
  },
  methods: {
    changesLang() {
      console.log("language changed!");
    },
    authenticate: function () {
      this.view = false;
      this.AccessToken = "Authenticating....";

      this.keycloak
        .init({
          onLoad: "login-required",
          checkLoginIframe: false,
          promiseType: "native",
        })
        .then((auth) => {
          if (!auth) {
            console.log("NOT Authenticated");
            this.AccessToken = "";
          } else {
            console.log("Authenticated");
            this.AccessToken = this.keycloak.token;
          }
          // set updated token
          this.$http.defaults.headers[
            "Authorization"
          ] = `Bearer ${this.keycloak.token}`;

          localStorage.setItem("ugems-accessToken", this.keycloak.token);
          localStorage.setItem(
            "ugems-refreshToken",
            this.keycloak.refreshToken
          );
          localStorage.setItem(
            "ugems-tokenParsed",
            JSON.stringify(this.keycloak.tokenParsed)
          );
          this.view = true;
        })
        .catch((err) => {
          console.log("Authenticated Failed");
          console.log("err", err);
          this.view = true;
        });
    },
    switchTemplate() {
      this.$refs.baseBody.classList.remove(
        "theme1",
        "theme2",
        "theme3",
        "theme4",
        "theme5",
        "theme6"
      );
      this.$refs.baseBody.classList.add(`theme${this.pick}`);
      console.log("switch", this.pick);
    },
    navClick(link) {
      const idx = this.menus.findIndex((e) => e.link === link);
      if (this.menus[idx].child) {
        let selected = this.menus[idx];

        if (this.$refs[selected.link][0].classList.contains("collapsed")) {
          this.$refs[selected.link][0].classList.remove("collapsed");
        }
      }
    },
    created() {
      if (this.$workbox) {
        this.$workbox.addEventListener("waiting", () => {
          this.showUpgradeUI = true;
        });
      }
    },
    logout() {
      this.$swal({
        title: "Confirm Logout",
        text: "Are you sure want to logout?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.isConfirmed) {
          let params = {
            client_id: "smart-presence",
            refresh_token: localStorage.getItem("ugems-refreshToken"),
          };
          LOGOUT(params)
            .then((resp) => {
              window.location.reload();
            })
            .catch((resp) => {
              this.$swal("Error", "jadi kirito", "error");
            });
        }
      });
    },
    printName() {
      const stringUser = localStorage.getItem("ugems-tokenParsed");
      if (stringUser) {
        const user = JSON.parse(stringUser);
        const given_name = user.given_name;
        return given_name;
      }
      return "Unknown";
    },
    switchTemplate() {
      this.$refs.baseBody.classList.remove(
        "theme1",
        "theme2",
        "theme3",
        "theme4",
        "theme5",
        "theme6"
      );
      this.$refs.baseBody.classList.add(`theme${this.pick}`);
      console.log("switch", this.pick);
    },
    navClick(link) {
      const idx = this.menus.findIndex((e) => e.link === link);
      if (this.menus[idx].child) {
        let selected = this.menus[idx];

        if (this.$refs[selected.link][0].classList.contains("collapsed")) {
          this.$refs[selected.link][0].classList.remove("collapsed");
        }
      }
      // if (this.indexTemp !== null) {
      //   this.menus[index].click = !this.menus[this.indexTemp].click;
      // }
      // this.menus[index].click = !this.menus[index].click;
      // this.indexTemp = index;
    },
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({
        type: "SKIP_WAITING",
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";

@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
/* MY CUSTOM CSS */
@import url("./assets/css/mycustom.css");

// #loader {
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   z-index: 10000;
//   background-color: white;
// }

// #loader>div {
//   position: static !important;
// }

.navbar-brand-img {
  max-width: 100% !important;
  max-height: 100% !important;
}
</style>
